import React from "react";

const MarketNotFound = () => {
    return <h1>This market does not exist yet or there is no data for this market.</h1>;
  };
  
  export default MarketNotFound;